import * as React from 'react';
import { useEffect, useState } from 'react';
import { useAlertStore } from 'src/hooks/Alert';
import { Pagination } from 'src/reusable/global';
import EOLSearchBox from './EOLSearchBox';
import useReduxState from 'src/hooks/useReduxState';
import { useAxiosIndicatorCheck } from "../../../store/hook/useAxiosIndicatorCheck";
import { useFilterSelectionStore } from 'src/hooks/component/filter_selection';
import Helper from 'src/support/Helper';
import Product from "@system/config/product";
import System from 'src/helper/system';
import Constants from 'src/support/Constants';

const EOLListingTable = (props) => {
    const [__check] = useAxiosIndicatorCheck();
    const [firstServerCall, setFirstServerCall] = useState(true);
    const [monitorFunctionCall, setMonitorFunctionCall] = useState(false);
    const [firstEOLCall, setFirstEOLCall] = useState(true)
    const [{ EOLAlertListingByType }, { get_alert_listing_by_type }] = useAlertStore();
    const [{ filter_list }, { }, { }] = useFilterSelectionStore();
    const [impactFilter] = useReduxState('', 'setImpactFilter');
    const { setExportParams } = props;
    const [AlertFirstServerCall] = useReduxState(false, 'setAlertFirstServerCall');
    const { alertTypes } = Constants;
    const [listObj, setListObj] = useState({
        pageCount: 0,
        page: 1,
        limit: 20,
        sortBy: '',
        sortOrder: '',
        ascDesField: {}
    });
    useEffect(() => {
        const getList = async () => {
            await fetchData();
            await setFirstServerCall(false);
        };
        getList();
    }, [EOLAlertListingByType]);

    useEffect(() => {
        const getList = async () => {
            await fetchAPiCall();
        };
        getList()
    }, [listObj.page, listObj.sortBy, listObj.sortOrder, impactFilter]);

    useEffect(() => {
        const getList = async () => {
            if (listObj.page === 1) {
                await fetchAPiCall()
            } else {
                await defaultPageActive()
            }
        };
        if (firstServerCall === false) {
            getList()
        }
    }, [listObj.limit]);

    useEffect(() => {
        if (!monitorFunctionCall && ((!firstEOLCall && !(__check('EOL_ALERT_API_CALL').status)) || AlertFirstServerCall)) {
            Helper.monitorJSDx()
            setMonitorFunctionCall(true)
        }
    }, [__check('EOL_ALERT_API_CALL').status, firstEOLCall, AlertFirstServerCall])

    const defaultPageActive = async () => {
        setListObj({ ...listObj, page: 1 })
    }

    const handlePageClick = async (data) => {
        let here_page = 0
        here_page = data.selected + 1;
        setListObj({ ...listObj, page: here_page })
        Helper.scrollTop();
    };

    const setPageLimit = async (event) => {
        await setListObj({ ...listObj, limit: event.target.value })
    };

    const fetchData = async () => {
        const total = EOLAlertListingByType.totalAlertList;
        setListObj({ ...listObj, pageCount: Math.ceil(total / listObj.limit) })
    };

    useEffect(() => {
        const getList = async () => {
            if (listObj.page === 1) {
                await fetchAPiCall()
            } else {
                await defaultPageActive()
            }
        };
        if (firstServerCall === false) {
            getList()
        }
    }, [filter_list])

    const fetchAPiCall = async (
        defaultStart = false
    ) => {
        let search_type = ''
        let search_keyword = ''
        if (filter_list.length > 0) {
            search_type = filter_list[0].key
            search_keyword = filter_list[0].searchKeyword
        }
        setExportParams(search_keyword, search_type, impactFilter, listObj.sortBy, listObj.sortOrder); // set params
        await get_alert_listing_by_type({
            "startRow": defaultStart ? 0 : (listObj.limit * (listObj.page - 1)),
            "pageSize": listObj.limit,
            "notificationType": alertTypes.EOL,
            "keyword": search_keyword,
            "searchType": search_type,
            "sortBy": listObj.sortBy,
            "sortOrder": listObj.sortOrder,
            "filterBy": impactFilter
        })
        setFirstEOLCall(false)
    };

    const toggleOrderBy = async (columnName) => {
        if (listObj.ascDesField.hasOwnProperty(columnName)) {
            listObj.ascDesField[columnName] = listObj.ascDesField[columnName] === 'ASC' ? 'DESC' : 'ASC'
            setListObj({ ...listObj, ascDesField: listObj.ascDesField})
           
        } else {
            listObj.ascDesField[columnName] = 'ASC'
            setListObj({ ...listObj, ascDesField: listObj.ascDesField})

        }
        setListObj({ ...listObj, sortBy: columnName,sortOrder:listObj.ascDesField[columnName] })

    };

    const getOrderByClass = (columnName) => {
        if (listObj.sortBy === columnName && listObj.ascDesField.hasOwnProperty(columnName)) {
            return 'sorting sorting_' + listObj.ascDesField[columnName].toLowerCase()
        }
        return 'sorting'
    };

    /**
     * Bug    #  : 9670
     * Change #  : Display download message on download
     * Change by : PN
     * Date      : 4 Aug 2023 
     */
    const showDownloadMessage = () => {
        System.alert(Constants.downloadMsg, 'success')
    }

    return (
        <>
            <EOLSearchBox />
            {(__check('EOL_ALERT_API_CALL').status || (EOLAlertListingByType.alertList !== undefined &&
                Object.entries(EOLAlertListingByType.alertList).length > 0)) &&
                <div className='position-relative'>
                    <div>
                        {__check(['EOL_ALERT_API_CALL'], { overlay: true }).render}
                    </div>
                    <>
                        <div className="table-container table-responsive m-b-30">
                            <table className="bs5 table table-bordered">
                                <thead>
                                    <tr className="align-middle">
                                        <th>
                                            Customer Part <br />
                                            Number
                                            <span
                                                className={'sort-container ' +
                                                    getOrderByClass('CPN')
                                                }
                                                onClick={async () => {
                                                    await toggleOrderBy('CPN')
                                                }}></span>
                                        </th>
                                        <th>Manufacturing Part Number
                                            <span
                                                className={'sort-container ' +
                                                    getOrderByClass('MPN')
                                                }
                                                onClick={async () => {
                                                    await toggleOrderBy('MPN')
                                                }}></span>
                                        </th>
                                        <th>Manufacturer
                                            <span
                                                className={'sort-container ' +
                                                    getOrderByClass('Manufacturer')
                                                }
                                                onClick={async () => {
                                                    await toggleOrderBy('Manufacturer')
                                                }}></span>
                                        </th>
                                        <th>EOL Download</th>
                                        <th><span>Issue Date</span>
                                            <span
                                                className={'sort-container ' +
                                                    getOrderByClass('IssueDate')
                                                }
                                                onClick={async () => {
                                                    await toggleOrderBy('IssueDate')
                                                }}></span>
                                        </th>
                                        <th><span>Last Time Buy</span>
                                            <span className={'sort-container ' +
                                                getOrderByClass('LastBuy')
                                            }
                                                onClick={async () => {
                                                    await toggleOrderBy('LastBuy')
                                                }}></span>
                                        </th>
                                        <th>Replacement</th>
                                    </tr>
                                </thead>
                                {EOLAlertListingByType.alertList &&
                                    Object.entries(EOLAlertListingByType.alertList).length > 0 &&
                                    <tbody>
                                        {EOLAlertListingByType.alertList.map((v, i) => (
                                            <React.Fragment key={i}>
                                                <tr>
                                                    <td>{v.customerPartNumber}</td>
                                                    <td>
                                                        {
                                                            v.product && v.product.ItemNumber ?
                                                                <a href={Product.getProductDetailPageRouteURLWithCustomParameter(v.product)
                                                                    + "?ERPPartNumber=" +
                                                                    v.product.ERPPartNumber + '&ItemNumber=' + v.product.ItemNumber}
                                                                    target="_blank"
                                                                    className="text-blue2 d-block font-bold" >{v.manufacturerPartNumber}</a>
                                                                :
                                                                <div>{v.manufacturerPartNumber}</div>
                                                        }
                                                    </td>
                                                    <td>{v.manufacturer}</td>
                                                    <td>
                                                        <a href={v.affectedParts} onClick={() => showDownloadMessage()}><i
                                                            className="fa fa-download me-3 text-black" /><span>EOL </span></a>
                                                    </td>
                                                    <td>{v.finalIssueDate}</td>
                                                    <td>{v.finalLastBuyDate}</td>
                                                    <td>{v.replacement}</td>
                                                </tr>
                                            </React.Fragment>
                                        ))
                                        }
                                    </tbody>
                                }

                            </table>
                        </div>
                        <Pagination pageCount={listObj.pageCount} handlePageClick={handlePageClick} setPageLimit={setPageLimit} page={listObj.page - 1} limit={listObj.limit} />
                        <div className="pagination-right"><span>Displaying <b>5</b> of <b>22</b> Items</span></div>
                    </>
                </div>
            }
            {(EOLAlertListingByType.alertList === undefined || EOLAlertListingByType.alertList.length === 0) &&
                __check('EOL_ALERT_API_CALL').status === false &&

                <div className='py-3 alert alert-info'>
                    <span className="text-center w-100">
                        No Alerts Found
                    </span>
                </div>
            }
        </>
    );
}

export default EOLListingTable;